<div class="constitution-container">
  <app-constitution-deed-object-section></app-constitution-deed-object-section>
  <app-constitution-capital-series-section [clientId]="clientId()"></app-constitution-capital-series-section>
  <app-constitution-socios-section [clientId]="clientId()" [activeTab]="activeTab()"></app-constitution-socios-section>
  <app-constitution-administration-section [clientId]="clientId()" [activeTab]="activeTab()"></app-constitution-administration-section>
  <app-constitution-representatives [activeTab]="activeTab()"></app-constitution-representatives>
  <div class="save-button-container">
    <button class="button save-button is-secondary" type="button" (click)="save()">
      <fa-icon class="save-icon" [icon]="faFloppyDisk"></fa-icon>
      <span>Guardar</span>
    </button>
  </div>
</div>

@if (store.isSaved()) {
  <div class="notification is-success">
    <div class="notification-text">
      Guardado correctamente.
    </div>
    <div class="progress-bar-container">
      <progress class="progress is-small" min="0" max="100"></progress>
    </div>
  </div>
}
